import { get, increment, ref, set, update } from "firebase/database";
import { db } from "../config/firebase.js";

const publicUser = (user) => ({
  nome: user.displayName || "Jogador",
  foto: user.photoURL || null,
  atualizadoEm: Date.now(),
});

const rows = (snapshot) =>
  snapshot.exists()
    ? Object.entries(snapshot.val()).map(([uid, value]) => ({ uid, ...value }))
    : [];

export async function salvarRecordeTermo(user, mode, attempts, seconds) {
  if (!user) return;
  const recordRef = ref(db, `rankingTermo/modo${mode}/${user.uid}`);
  const snapshot = await get(recordRef);
  const current = snapshot.exists() ? snapshot.val() : null;
  if (
    !current ||
    attempts < current.tentativas ||
    (attempts === current.tentativas && seconds < current.tempoSegundos)
  ) {
    await set(recordRef, {
      ...publicUser(user),
      tentativas: attempts,
      tempoSegundos: seconds,
    });
  }
}

export async function listarRankingTermo(mode) {
  return rows(await get(ref(db, `rankingTermo/modo${mode}`))).sort(
    (a, b) => a.tentativas - b.tentativas || a.tempoSegundos - b.tempoSegundos,
  );
}

export async function salvarRecordeQuebraCabeca(user, difficulty, seconds) {
  if (!user) return;
  const recordRef = ref(db, `rankingQuebraCabeca/d${difficulty}/${user.uid}`);
  const snapshot = await get(recordRef);
  const current = snapshot.exists() ? snapshot.val() : null;
  if (!current || seconds < current.tempoSegundos) {
    await set(recordRef, { ...publicUser(user), tempoSegundos: seconds });
  }
}

export async function listarRankingQuebraCabeca(difficulty) {
  return rows(await get(ref(db, `rankingQuebraCabeca/d${difficulty}`))).sort(
    (a, b) => a.tempoSegundos - b.tempoSegundos,
  );
}

export async function salvarRecordeStop(user, hits, seconds) {
  if (!user) return;
  const recordRef = ref(db, `rankingStop/${user.uid}`);
  const snapshot = await get(recordRef);
  const current = snapshot.exists() ? snapshot.val() : null;
  if (
    !current ||
    hits > current.acertos ||
    (hits === current.acertos && seconds < current.tempoSegundos)
  ) {
    await set(recordRef, {
      ...publicUser(user),
      acertos: hits,
      tempoSegundos: seconds,
    });
  }
}

export async function listarRankingStop() {
  return rows(await get(ref(db, "rankingStop"))).sort(
    (a, b) => b.acertos - a.acertos || a.tempoSegundos - b.tempoSegundos,
  );
}

async function registrarVitoria(path, user) {
  if (!user) return;
  await update(ref(db, `${path}/${user.uid}`), {
    ...publicUser(user),
    vitorias: increment(1),
  });
}

async function listarVitorias(path) {
  return rows(await get(ref(db, path))).sort(
    (a, b) => (b.vitorias || 0) - (a.vitorias || 0),
  );
}

export const registrarVitoriaTermo = (user, mode) =>
  registrarVitoria(`rankingVitoriasTermo/modo${mode}`, user);
export const listarVitoriasTermo = (mode) =>
  listarVitorias(`rankingVitoriasTermo/modo${mode}`);
export const registrarVitoriaQuebraCabeca = (user, difficulty) =>
  registrarVitoria(`rankingVitoriasQuebraCabeca/d${difficulty}`, user);
export const listarVitoriasQuebraCabeca = (difficulty) =>
  listarVitorias(`rankingVitoriasQuebraCabeca/d${difficulty}`);
export const registrarVitoriaStop = (user) =>
  registrarVitoria("rankingVitoriasStop", user);
export const listarVitoriasStop = () => listarVitorias("rankingVitoriasStop");
